// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "[data-v-9a895770] .multiselect .multiselect__tags .multiselect__single {\n    padding-left: 0px\n}", "",{"version":3,"sources":["/app/app/javascript/dashboard/routes/dashboard/conversation/contact/ContactForm.vue"],"names":[],"mappings":"AAGI;IAAA;AAAA","file":"ContactForm.vue","sourcesContent":["\n::v-deep {\n  .multiselect .multiselect__tags .multiselect__single {\n    @apply pl-0;\n  }\n}\n"]}]);
// Exports
module.exports = exports;
